import type { FlattenSimpleInterpolation } from 'styled-components'
import styled, { css } from 'styled-components'

import type { StyledIconProps } from './SliderIcon.style.types'

export const IconWrapper = styled.div<StyledIconProps>((props: StyledIconProps): FlattenSimpleInterpolation => {
  return css`
    ${props.position === 'left' &&
    css`
      margin-right: 26px;
    `}
    ${props.position === 'right' &&
    css`
      margin-left: 20px;
    `}
  `
})
